<div class="flex flex-col gap-16 py-(--spacing-layout-l) h-full min-h-0">
    <div class="flex justify-center items-center h-10 shrink-0">
        <a class="cursor-pointer" (click)="redirectToDashboard()">
            <img src="/logos/logo-full.svg" alt="BettaAlpha" class="w-full h-full object-contain" />
        </a>
    </div>
    <div class="flex-1 min-h-0 overflow-y-auto hide-scrollbar">
        <app-menu></app-menu>
    </div>

    @if (isClientUser) {
    <div class="shrink-0 flex flex-col gap-3">
        <!-- Wealth Manager card: logo, name, badge -->
        <div class="flex items-center gap-3 rounded-12 bg-backgroundWhite p-4 w-full overflow-auto">
            <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-primaryBorder">
                @if (_userProfileService.userProfileData()?.wealthManagerLogoUrl) {
                <app-avatar [image]="_userProfileService.userProfileData()!.wealthManagerLogoUrl!" size="small" />
                } @else {
                <svg-icon src="/icons/user.svg" svgClass="w-7 h-7" />
                }
            </div>
            <div class="shrink-0 flex flex-col gap-2 pr-2">
                <div class="whitespace-nowrap text-subheading-medium text-headingText">{{ _userProfileService.userProfileData()?.wealthManagerName ?? 'Loading...' }}</div>
                <app-tag value="Wealth Manager" severity="removed" />
            </div>
        </div>
        <!-- Relationship Manager card: profile picture, name, badge, email icon -->
        <div class="flex items-center gap-3 rounded-12 bg-backgroundWhite p-4 w-full overflow-auto">
            <div class="flex justify-center items-center h-10 w-10 shrink-0 overflow-hidden rounded-full border border-primaryBorder">
                @if (_userProfileService.userProfileData()?.relationshipManagerProfilePictureUrl) {
                <app-avatar [image]="_userProfileService.userProfileData()!.relationshipManagerProfilePictureUrl!" size="small" />
                } @else {
                <svg-icon src="/icons/user.svg" svgClass="w-7 h-7" />
                }
            </div>
            <div class="shrink-0 flex flex-col gap-2 pr-2">
                <div class="whitespace-nowrap text-subheading-medium text-headingText">{{ _userProfileService.userProfileData()?.relationshipManagerName ?? 'Loading...' }}</div>
                <div class="flex items-center gap-2">
                    <app-tag value="Relationship Manager" severity="removed" />
                    <!-- @if (_userProfileService.userProfileData()?.relationshipManagerEmailAddress) {
                   <svg-icon src="/icons/Email.svg" svgClass="w-5 h-5" />
                    } -->
                </div>
            </div>
        </div>
    </div>
    } @if (isRelationshipManagerUser) {
    <div class="shrink-0 flex flex-col gap-3">
        <!-- Wealth Manager card: logo, name, badge -->
        <div class="flex items-center gap-3 rounded-12 bg-backgroundWhite p-4 w-full overflow-auto">
            <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-primaryBorder">
                @if (_userProfileService.userProfileData()?.wealthManagerLogoUrl) {
                <app-avatar [image]="_userProfileService.userProfileData()!.wealthManagerLogoUrl!" size="small" />
                } @else {
                <svg-icon src="/icons/user.svg" svgClass="w-7 h-7" />
                }
            </div>
            <div class="shrink-0 flex flex-col gap-2 pr-2">
                <div class="whitespace-nowrap text-subheading-medium text-headingText">{{ _userProfileService.userProfileData()?.wealthManagerName ?? 'Loading...' }}</div>
                <app-tag value="Wealth Manager" severity="removed" />
            </div>
        </div>
    </div>
    } @if (isWealthManagerUser) {
    <div class="shrink-0 flex flex-col gap-3">
        <div class="flex items-center gap-3 rounded-12 bg-backgroundWhite p-4 w-full overflow-auto">
            <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-primaryBorder">
                @if (_userProfileService.userProfileData()?.companyLogoUrl) {
                <app-avatar [image]="_userProfileService.userProfileData()!.companyLogoUrl!" size="small" />
                } @else {
                <svg-icon src="/icons/user.svg" svgClass="w-7 h-7" />
                }
            </div>
            <div class="shrink-0 flex flex-col gap-2 pr-2">
                <div class="whitespace-nowrap text-subheading-medium text-headingText">{{ _userProfileService.userProfileData()?.entityName ?? 'Loading...' }}</div>
                <app-tag value="Wealth Manager" severity="removed" />
            </div>
        </div>
    </div>
    }
</div>
